import { cartFlowSequence } from "./cartFlowSequence";

export function isNextPageSampleQuestions(nextIndex: number, pathname: string) {
  if (pathname.includes("/sample-user-registration")) {
    return cartFlowSequence.findIndex(
      (item) => item.errorPage === "SampleQuestions"
    );
  } else {
    return nextIndex;
  }
}
